<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-head"><a id="dedication"></a><a id="page_v"><span class="txit">For my parents</span></a></p><a id="page_v">
<p class="ded"><span class="txit">Mary and George Mitchell</span></p>
</a><p class="imagec"><a id="page_v"></a><a id="img00"><img alt="Images" src="images/ded.jpg"/></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1069e659